import client from './client';

export const listCskhLogs = (params) => client.get('/cskh-logs', { params }).then((r) => r.data);
export const createCskhLog = (payload) => client.post('/cskh-logs', payload).then((r) => r.data);
export const updateCskhLog = (id, payload) => client.put(`/cskh-logs/${id}`, payload).then((r) => r.data);
export const removeCskhLog = (id) => client.delete(`/cskh-logs/${id}`).then((r) => r.data);
// Bổ sung nội dung cho việc đã ghi + xác nhận đã xử lí xong (XLKN / KH không hài lòng).
export const addCskhUpdate = (id, text) => client.post(`/cskh-logs/${id}/status`, { text }).then((r) => r.data);
export const resolveCskhLog = (id, done = true) => client.post(`/cskh-logs/${id}/resolve`, { done }).then((r) => r.data);
export const getCskhWeekReport = (from, to) =>
  client.get('/cskh-logs/week-report', { params: { from, to } }).then((r) => r.data);
export const saveCskhWeekReport = (payload) => client.post('/cskh-logs/week-report', payload).then((r) => r.data);
export const listCskhWeekReports = () => client.get('/cskh-logs/week-reports').then((r) => r.data);
export const getCskhWeekReportById = (id) => client.get(`/cskh-logs/week-reports/${id}`).then((r) => r.data);
